// Services/hubspot.ts
import { api } from "./api"; // your base api with baseQuery + token handling

export interface OAuthStartResponse {
  authorization_url: string;
  state: string;
  expires_in: number;
}

export interface OAuthStatusResponse {
  connected: boolean;
  tenant_id: string;
  hub_id: number;
  hub_domain: string;
  status: string;
  connected_at: string;
  last_refreshed_at: string;
  sync_run_id?: string;
}

export interface SyncStartResponse {
  sync_run_id: string;
}

export interface TriggerOAuthSyncResponse {
  success: boolean;
  tenant_id: string;
  hub_id: number;
  sync_triggered: boolean;
  sync_execution_arn?: string;
  sync_run_id?: string;
  message: string;
}

export interface SyncRunStatusResponse {
  sync_run_id: string;
  status: "in_progress" | "complete" | "complete_with_errors" | "failed";
  expected_shards: number;
  completed_shards: number;
  error_shards: number;
}

export const hubspotApi = api.injectEndpoints({
  endpoints: (build) => ({
    startConnect: build.mutation<OAuthStartResponse, void>({
      query: () => ({
        url: "hubspot/oauth/start-connect",
        method: "POST",
      }),
    }),
    getStatus: build.query<OAuthStatusResponse, void>({
      query: () => "hubspot/oauth/status",
      keepUnusedDataFor: 0,
    }),
    triggerSync: build.mutation<SyncStartResponse, string>({
      query: (companyId) => ({
        url: `integration/hubspot/company/${companyId}/sync`,
        method: "POST",
      }),
    }),
    getSyncRunStatus: build.query<
      SyncRunStatusResponse,
      { companyId: string; syncRunId: string }
    >({
      query: ({ companyId, syncRunId }) =>
        `integration/hubspot/company/${companyId}/sync/${syncRunId}/status`,
      keepUnusedDataFor: 0,
    }),
    triggerOAuthSync: build.mutation<TriggerOAuthSyncResponse, void>({
      query: () => ({
        url: "hubspot/oauth/trigger-sync",
        method: "POST",
      }),
    }),
    disconnect: build.mutation<void, void>({
      query: () => ({
        url: "hubspot/oauth/disconnect",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useStartConnectMutation,
  useGetStatusQuery,
  useLazyGetStatusQuery,
  useTriggerSyncMutation,
  useTriggerOAuthSyncMutation,
  useGetSyncRunStatusQuery,
  useDisconnectMutation,
} = hubspotApi;
